import React from "react"
import BatteryGauge from 'react-battery-gauge';
import { NetworkIcon } from '@util/svgicon';
import { getNetworkLabel } from '@util/networkState';
import { useSelector } from "react-redux";
import GameRemoteIcon from '@images/newPlayGame/akar-icons_game-controller.svg';
import GreenDotIcon from '@images/newPlayGame/greenDot.svg';
import RedDotIcon from '@images/newPlayGame/redDot.svg';

const batterystyle = {
    batteryBody: {
        strokeWidth: 6,
        cornerRadius: 10,
        fill: 'none',
        strokeColor: '#FFFFFF'
    },
    batteryCap: {
        fill: 'none',
        strokeWidth: 6,
        strokeColor: '#FFFFFF',
        cornerRadius: 2,
        capToBodyRatio: 0.4
    },
    batteryMeter: {
        fill: '#FFFFFF',
        lowBatteryValue: 15,
        lowBatteryFill: '#FF0000',
        outerGap: 5,
        noOfCells: 1,
        interCellsGap: 0,
    },
    chargingFlash: {
        scale: undefined,
        fill: 'red',
        animated: true,
        animationDuration: 100
    },
}

const RobotGeneralDetails = () => {
    const robotDetails = useSelector((state) => state.robotDetails);
    const robotConnection = useSelector((state) => state.robotConnection);
    const hideMenu = useSelector((state) => state.hideMenu.hideMenu);

    return (
        <>
            {hideMenu && (
                <div className="robot-details-container">
                    <div className="battery-indicator">
                        <BatteryGauge value={robotDetails?.BatteryVoltage} orientation="horizontal" aspectRatio='0.54' size={32} maxValue={100} customization={batterystyle} />
                        <p id="battery-percentage" className="batter-percentage-letter" >{`${robotDetails?.BatteryVoltage}%`}</p>
                    </div>
                    <div className="hud-indicator">
                        <NetworkIcon signal={robotDetails?.Signal} networkState={robotDetails?.NetworkState} />
                        <p className="signal-letter">{getNetworkLabel(robotDetails?.NetworkState)}</p>
                    </div>
                    <div className="remote-indicator">
                        <img src={GameRemoteIcon} alt="Game Remote Icon" />
                        <div id="battery-connection" className="connection">
                            {robotConnection?.robotConnect === 'Connected' ?
                                <img src={GreenDotIcon} alt="Green Dot Icon" />
                                :
                                <img src={RedDotIcon} alt="Red Dot Icon" />
                            }
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default RobotGeneralDetails;
